'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _templateObject = _taggedTemplateLiteral(['\n  cursor: pointer;\n  color: ', ';\n'], ['\n  cursor: pointer;\n  color: ', ';\n']),
  _templateObject2 = _taggedTemplateLiteral(['\n  position: relative;\n'], ['\n  position: relative;\n']),
  _templateObject3 = _taggedTemplateLiteral(['\n  div[name=\'headerCell\'] {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  span {\n    margin-right: 10px;\n  }\n'], ['\n  div[name=\'headerCell\'] {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  span {\n    margin-right: 10px;\n  }\n']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _reactFontawesome = require('@fortawesome/react-fontawesome');
var _freeSolidSvgIcons = require('@fortawesome/free-solid-svg-icons');
var _XactlyColors = require('../../themes/XactlyColors');
var _XactlyColors2 = _interopRequireDefault(_XactlyColors);
var _FilterDropdown = require('./FilterDropdown');
var _FilterDropdown2 = _interopRequireDefault(_FilterDropdown);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var IconWrapperStyled = _styledComponents2['default'].span.withConfig({
  displayName: 'HeaderCell__IconWrapperStyled',
  componentId: 'sc-1fsu8vk-0'
})(_templateObject, function (props) {
  return props.isSelected ? props.selectedColor : _XactlyColors2['default'].xGreyDark;
});
var FilterWrapper = _styledComponents2['default'].div.withConfig({
  displayName: 'HeaderCell__FilterWrapper',
  componentId: 'sc-1fsu8vk-1'
})(_templateObject2);
var HeaderCellBase = function (_Component) {
  _inherits(HeaderCellBase, _Component);
  function HeaderCellBase() {
    _classCallCheck(this, HeaderCellBase);
    return _possibleConstructorReturn(this, (HeaderCellBase.__proto__ || Object.getPrototypeOf(HeaderCellBase)).apply(this, arguments));
  }
  _createClass(HeaderCellBase, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
          className = _props.className,
          children = _props.children,
          filterable = _props.filterable,
          rowSpan = _props.rowSpan,
          colSpan = _props.colSpan,
          sorting = _props.sorting;
        if (sorting || filterable) {
          return this.renderCustomCell();
        }
        return _react2['default'].createElement('th', {
          className: className,
          colSpan: colSpan,
          rowSpan: rowSpan
        }, children);
      }
      return render;
    }()
  }, {
    key: 'renderCustomCell',
    value: function () {
      function renderCustomCell() {
        var _props2 = this.props,
          children = _props2.children,
          className = _props2.className,
          colSpan = _props2.colSpan,
          rowSpan = _props2.rowSpan;
        return _react2['default'].createElement('th', {
          className: className,
          colSpan: colSpan,
          rowSpan: rowSpan
        }, _react2['default'].createElement('div', {
          name: 'headerCell'
        }, _react2['default'].createElement('span', null, children), this.renderSortIcon(), this.renderFilterIcon()));
      }
      return renderCustomCell;
    }()
  }, {
    key: 'renderSortIcon',
    value: function () {
      function renderSortIcon() {
        var _props3 = this.props,
          columnValue = _props3.columnValue,
          isSorted = _props3.isSorted,
          sorting = _props3.sorting,
          sortClickHandler = _props3.sortClickHandler,
          sortDirection = _props3.sortDirection;
        if (sorting) {
          var sortIcon = _react2['default'].createElement(_reactFontawesome.FontAwesomeIcon, {
            icon: _freeSolidSvgIcons.faSort
          });
          if (isSorted) {
            sortIcon = _react2['default'].createElement(_reactFontawesome.FontAwesomeIcon, {
              icon: sortDirection === 'ASCEND' ? _freeSolidSvgIcons.faSortUp : _freeSolidSvgIcons.faSortDown
            });
          }
          return _react2['default'].createElement(IconWrapperStyled, {
            isSelected: isSorted,
            onClick: function () {
              function onClick() {
                return sortClickHandler(columnValue);
              }
              return onClick;
            }(),
            selectedColor: _XactlyColors2['default'].xCoalModerate
          }, sortIcon);
        } else {
          return null;
        }
      }
      return renderSortIcon;
    }()
  }, {
    key: 'renderFilterIcon',
    value: function () {
      function renderFilterIcon() {
        var _props4 = this.props,
          columnValue = _props4.columnValue,
          isFiltered = _props4.isFiltered,
          filterable = _props4.filterable,
          filterClickHandler = _props4.filterClickHandler;
        if (filterable) {
          return _react2['default'].createElement('span', null, _react2['default'].createElement(IconWrapperStyled, {
            isSelected: isFiltered,
            onClick: function () {
              function onClick() {
                return filterClickHandler(columnValue);
              }
              return onClick;
            }(),
            selectedColor: _XactlyColors2['default'].xSky
          }, _react2['default'].createElement(_reactFontawesome.FontAwesomeIcon, {
            icon: _freeSolidSvgIcons.faFilter
          })), this.renderFilter());
        } else {
          return null;
        }
      }
      return renderFilterIcon;
    }()
  }, {
    key: 'renderFilter',
    value: function () {
      function renderFilter() {
        var _props5 = this.props,
          columnValue = _props5.columnValue,
          isFilterOpen = _props5.isFilterOpen,
          filters = _props5.filters,
          filterClickHandler = _props5.filterClickHandler,
          filterItems = _props5.filterItems,
          filterSelectionHandler = _props5.filterSelectionHandler;
        return isFilterOpen && _react2['default'].createElement(FilterWrapper, null, _react2['default'].createElement(_FilterDropdown2['default'], {
          items: filterItems,
          filterGroup: columnValue,
          filterClickHandler: filterClickHandler,
          handleSelection: filterSelectionHandler,
          selectedValues: filters[columnValue]
        }));
      }
      return renderFilter;
    }()
  }]);
  return HeaderCellBase;
}(_react.Component);
HeaderCellBase.propTypes = {
  children: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].element]).isRequired,
  className: _propTypes2['default'].string,
  columnValue: _propTypes2['default'].string,
  colSpan: _propTypes2['default'].number,
  isFiltered: _propTypes2['default'].bool,
  isFilterOpen: _propTypes2['default'].bool,
  filterable: _propTypes2['default'].bool,
  filters: _propTypes2['default'].object,
  filterClickHandler: _propTypes2['default'].func,
  filterSelectionHandler: _propTypes2['default'].func,
  filterItems: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
    name: _propTypes2['default'].string.isRequired,
    value: _propTypes2['default'].string.isRequired
  })),
  rowSpan: _propTypes2['default'].number,
  isSorted: _propTypes2['default'].bool,
  sorting: _propTypes2['default'].bool,
  sortClickHandler: _propTypes2['default'].func,
  sortDirection: _propTypes2['default'].oneOf(['ASCEND', 'DESCEND'])
};
var HeaderCell = (0, _styledComponents2['default'])(HeaderCellBase)(_templateObject3);
HeaderCell.displayName = 'DataTable-HeaderCell';
exports['default'] = HeaderCell;